export const APPLICATION_ID =
  process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID ?? '';
export const CLIENT_TOKEN = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? '';
export const DATADOG_SERVICE = process.env.NEXT_PUBLIC_DATADOG_SERVICE ?? '';
export const DATADOG_ENV = process.env.NEXT_PUBLIC_DATADOG_ENV ?? '';
export const DATADOG_SITE = process.env.NEXT_PUBLIC_DATADOG_SITE ?? '';

export const PROPERTY_SERVICE =
  process.env.NEXT_PUBLIC_API_BASE_URL_PROPERTY_SERVICE ?? '';
export const SEARCH_SERVICE =
  process.env.NEXT_PUBLIC_API_BASE_URL_SEARCH_SERVICE ?? '';
export const DESTINATION_SERVICE =
  process.env.NEXT_PUBLIC_API_BASE_URL_DESTINATION ?? '';
export const LA_DOC_SERVICE =
  process.env.NEXT_PUBLIC_API_BASE_URL_LA_DOC_SERVICE ?? '';
export const API_SERVICE_URL = 'azurewebsites.net';
